import type { RealtimeEventType, RealtimeHandler } from "./RealtimeHandler";
import { realtimeHandlers } from "./realtimeHandlers";

// Регистрация обработчика события в общем реестре. Возвращает функцию отписки.
//
//   registerRealtimeHandler("analysis.done", (event, { queryClient }) => {
//     void queryClient.invalidateQueries({ queryKey: [...] });
//   });
export const registerRealtimeHandler = <T extends RealtimeEventType>(
  type: T,
  handler: RealtimeHandler<T>,
): (() => void) => realtimeHandlers.register(type, handler);
